import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { getMetaVerifications } from '@seek/seek-jobs-seo';
import Dashboard from 'Dashboard/Dashboard';
import SARABanner from 'SARABanner/SARABanner';
import ContentSlider from 'ContentSlider/ContentSlider';
import QuickSearch from 'QuickSearch/QuickSearch';
import Helmet from 'react-helmet';
import LoggedInBanner from 'LoggedInBanner/LoggedInBanner';
import LoggedOutBanner from 'LoggedOutBanner/LoggedOutBanner';

const renderBanner = (locale, authenticated) => locale === 'NZ' ?
  <SARABanner {...{ locale }} /> : authenticated && <LoggedInBanner /> || <LoggedOutBanner />;

@connect(({ user, location }) => ({
  authenticated: user.authenticated,
  locale: location.locale
}))
export default class HomePage extends Component {
  static propTypes = {
    authenticated: PropTypes.bool.isRequired,
    locale: PropTypes.string.isRequired
  };

  render() {
    const { locale, authenticated } = this.props;
    const { meta, link, script } = getMetaVerifications(locale);

    return (
      <div>
        <Helmet
          meta={meta}
          link={link}
          script={script}
        />
        <Dashboard />
        <ContentSlider trigger="dashboard">
          {renderBanner(locale, authenticated)}
          <QuickSearch />
        </ContentSlider>
      </div>
    );
  }

}



/** WEBPACK FOOTER **
 ** ./app/components/HomePage/HomePage.js
 **/